import r from "axios";
const s = async (o, t, a) => {
  const { data: p } = await r.post(
    `https://${o}.vtex.app/api/coupon/order`,
    {
      orderFormId: t,
      couponId: a
    }
  );
  return p;
};
export {
  s as addCoupon
};
